import { toast } from 'react-toastify';
import apiClient from '../utils/apiCliente';

export const obtenerViandasAdmin = async (token, incluirInactivos = true) => {
	const headers = { Authorization: `Bearer ${token}` };

	try {
		if (incluirInactivos) {
			try {
				const response = await apiClient.get('/viandas?incluir_inactivos=true', { headers });
				return response.data;
			} catch (error) {
				if (error.response?.status !== 404 && error.response?.status !== 400) {
					throw error;
				}
			}
		}

		const fallbackResponse = await apiClient.get('/viandas', { headers });
		return fallbackResponse.data;
	} catch (error) {
		if (error.response) {
			if (error.response.status === 401) {
				toast.info('Su sesión ha expirado. Por favor, inicie sesión nuevamente.', {
					onClose: () => {
						window.location.href = '/login';
					},
				});
			} else {
				const errorData = error.response.data;
				throw new Error(errorData.error || 'Se produjo un error al obtener viandas.');
			}
		} else if (error.request) {
			throw new Error('No se pudo establecer conexión con el servidor.');
		} else {
			throw new Error('Error al realizar la solicitud.');
		}
	}
};
